module.exports = require("@angular/common");